module.exports = __webpack_public_path__ + "img/5.92335dc6.jpg";